import React, { Fragment } from 'react'
import AIAnswerViewModel from "./ViewModels/AIAnswerViewModel";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Alert, { AlertColor } from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { Theme } from "@mui/material/styles/createTheme";

interface IAIAnswersProps {
    answers: AIAnswerViewModel[] | null
    isLoading: boolean
}

const styles = {
    paper: {
        padding: (theme: Theme) => theme.spacing(2),
        height: '100%',
        width: '100%',
    },
    fullHeight: {
        height: '100%'
    },
    scroll: {
        height: '100%',
        overflowY: 'auto',
    }
}

export default function AIAnswers(props: IAIAnswersProps) {


    const getAlertType = (answer: AIAnswerViewModel): AlertColor => {
        if (answer.explanationVisible !== null) {
            return answer.answer.includes(answer.explanationVisible) ? "warning" : "success"
        }
        return "success";
    }

    const formatAnswer = (answer: AIAnswerViewModel) => {
        if (answer.questionCategory === "Vulnerabilities" || answer.questionCategory === "Complaints") {
            return answer.answer.split("-")[0];
        }
        else {
            return answer.answer
                .split("-")
                .map((line, index, lines) =>
                (
                    index === 0 ?
                        <Fragment key={index}>{line}<br /></Fragment>
                        :
                        index < lines.length - 1 ?
                            `${line} -`
                            : `${line}`
                )
                )
        }
    }

    const formatExplanation = (answer: AIAnswerViewModel) => {
        let lines = answer.explanation?.split(";") ?? [];
        for (let i = 0; i < lines.length; i++) {
            lines[i] = lines[i].trim().charAt(0).toUpperCase() + lines[i].trim().slice(1);
        }
        if (lines.length > 2) {
            return (
                <i>
                    <Fragment>
                        <b>Agent result: </b>
                        {lines[0]}<br />
                    </Fragment>
                    <Fragment>
                        <b>AI result: </b>
                        {lines[1]}<br />
                    </Fragment>
                    {lines.map((line, index) => (
                        index > 1 && line
                    ))}
                </i>
            )
        }
        else {
            return (
                <i>
                    <Fragment>
                        {
                            answer.answerCategory && <Fragment><b>Category: </b>{answer.answerCategory}<br /></Fragment>
                        }
                        {
                            lines
                                .map((line, index) => (
                                    <Fragment key={index}>{line}<br /></Fragment>))
                        }
                    </Fragment>
                </i>
            )
        }
    }

    const formatQuestion = (answer: AIAnswerViewModel) => {
        let result = '';
        if (answer.questionCategory) result += `${answer.questionCategory} - `;
        result += `${answer.questionLabel ?? answer.question} - `;
        return result;
    }

    return (
        props.isLoading ?
            <Grid container justifyContent="center" alignItems="center" size={12} padding="40%" sx={{ height: "100%" }}>
                <Grid>
                    <CircularProgress size={50} />
                </Grid>
            </Grid>
            :
            <Box sx={styles.scroll}>
                {
                    props.answers?.length === 0 ?
                        <Grid container justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
                            <Grid>
                                <Typography variant="h4" textAlign="center">No AI analysis found for this call</Typography>
                            </Grid>
                        </Grid>
                        :
                        <Paper sx={{ padding: 1, paddingLeft: 0 }}>
                            {
                                props.answers!.map((answer, index) => {
                                    return (
                                        <Grid key={index} size={12} paddingBottom={index !== props.answers!.length - 1 ? 1 : 0}>
                                            <Alert severity={getAlertType(answer)}>
                                                <AlertTitle>
                                                    {
                                                        formatQuestion(answer)
                                                    }
                                                    {
                                                        formatAnswer(answer)
                                                    }
                                                </AlertTitle>
                                                {
                                                    <Fragment>
                                                        {
                                                            formatExplanation(answer)
                                                        }
                                                    </Fragment>
                                                }
                                            </Alert>
                                        </Grid>
                                    )
                                }
                                )
                            }
                        </Paper>
                }
            </Box >
    );
}